import {OVRecommendActionEnum} from '../../../schema-types/globalTypes';
import {BUILDER_SUBTYPE_TO_SERVER} from '../constants/SolutionType';
import validateUUID from '../../../utils/validateUUID';
import {
  getPotContactId,
  updateRecsVarsProps,
  upsertBuilderHeader,
} from './builderHelpers';

export const saveNew = async (props: updateRecsVarsProps): Promise<string> => {
  const {accountId, values} = props;
  const {setUpNew, contact, urgency, urgencyReason} = values;

  const ovrecommendId = await upsertBuilderHeader(props, {
    action: OVRecommendActionEnum.SET_UP_NEW,
    accountId: validateUUID(accountId),
    goalId: validateUUID(values.goal?.id),
    isNewPlanRequired: true,
    contactId: getPotContactId(contact),
    urgency,
    urgencyReason,
    productProviderId: setUpNew?.parent?.planProvider,
    productNameId: setUpNew?.parent?.productNameId,
    parentGuardianId: validateUUID(setUpNew?.parent?.parentGuardianId),
  });

  const seenPotIds = new Set<string>();
  const subplans = (setUpNew?.subplans ?? [])
    .filter((subplanObj) => {
      const potId = subplanObj.existingPotId;
      if (!potId) return true;
      if (seenPotIds.has(potId)) return false;
      seenPotIds.add(potId);
      return true;
    })
    .map((subplanObj) => ({
      modelPortfolioId:
        typeof subplanObj.model !== 'string'
          ? validateUUID(subplanObj.model?.id || '')
          : null,
      mandate: typeof subplanObj.model === 'string' ? subplanObj.model : null,
    }));

  await props.upsertSetUpNew({
    variables: {
      ovrecommendId: validateUUID(ovrecommendId)!,
      productProviderId: setUpNew?.parent?.planProvider,
      productNameId: setUpNew?.parent?.productNameId,
      subplans,
    },
  });

  return ovrecommendId;
};
